import {Observable} from 'rxjs';
import {CommonService} from '../../../shared/utils/common.service';
import {UtilsService} from '../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';

@Injectable({
  providedIn: 'root',
})
export class PorcentajeToleranciaNivelesPesoService {
  private diccionarioModulo: any;
  private url: string;
  private urlMaestros: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
    this.urlMaestros = this._util.getDatosMaestros();
  }

  obtener(): Observable<any[]> {
    return this._commom.peticionGetConHeader(
      (this.url + this.diccionarioModulo.url.porcentajeToleranciaNivelesPeso.obtenerTodo)
    );
  }

  crear(request: any): any {
    return this._commom.peticionPostConHeader(
      (this.url + this.diccionarioModulo.url.porcentajeToleranciaNivelesPeso.crear),
      request
    );
  }

  actualizar(request: any): Observable<any> {
    return this._commom.peticionPutConHeader(
      (this.url + this.diccionarioModulo.url.porcentajeToleranciaNivelesPeso.actualizar),
      request
    );
  }

  borrar(idValorFlete: any): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      (this.url +
        this.diccionarioModulo.url.porcentajeToleranciaNivelesPeso.eliminar +
        idValorFlete)
    );
  }

  getMaterial(idMaterial: any): Observable<any> {
    return this._commom.peticionGetConHeader(
      (this.urlMaestros + this.diccionarioModulo.url.porcentajeToleranciaNivelesPeso.getMaterial + idMaterial)
    );
  }

}
